/**
 * @copyright  (c) 2026 Paul Höcker | PHMG. All rights reserved.
 * @license        GPLv3
 */

import breakpointsInterfaceFactory from "@phmg/apis/src/js/interface/breakpoints.js";
import dataInterfaceFactory from "@phmg/apis/src/js/interface/data.js";
import formatInterfaceFactory from "@phmg/apis/src/js/interface/format.js";
import bsbridgeInterfaceFactory from "@phmg/apis/src/js/interface/flavours/bsbridge-v4.6.js";
import eventInterfaceFactory from "@phmg/apis/src/js/interface/event.js";
import debugInterfaceFactory from "@phmg/apis/src/js/interface/debug.js";
import domInterfaceFactory from "@phmg/apis/src/js/interface/dom.js";
import featureInterfaceFactory from "@phmg/apis/src/js/interface/feature.js";
import messageInterfaceFactory from "@phmg/apis/src/js/interface/message.js";
import sessionInterfaceFactory from "@phmg/apis/src/js/interface/session.js";
import timerInterfaceFactory from "@phmg/apis/src/js/interface/timer.js";
import translateInterfaceFactory from "@phmg/apis/src/js/interface/translate.js";
import FormHandler from "./exports/FormHandler.js";
import CallHandler from "./exports/CallHandler.js";
import Utils from "./exports/Utils.js";

const DATA_KEY = "hv.core"
const EVENT_DEFINED = "defined." + DATA_KEY
const EVENT_BUILT = "built." + DATA_KEY
const HiveInterface = window.Hive || {};
window.dispatchEvent(new CustomEvent(EVENT_DEFINED));

HiveInterface.formatInterface = formatInterfaceFactory(HiveInterface);
HiveInterface.dataInterface = dataInterfaceFactory(HiveInterface);
HiveInterface.sessionInterface = sessionInterfaceFactory(HiveInterface);
HiveInterface.debugInterface = debugInterfaceFactory(HiveInterface);
HiveInterface.timerInterface = timerInterfaceFactory(HiveInterface);
HiveInterface.eventInterface = eventInterfaceFactory(HiveInterface);
HiveInterface.breakpointsInterface = breakpointsInterfaceFactory(HiveInterface);
HiveInterface.featureInterface = featureInterfaceFactory(HiveInterface);
HiveInterface.domInterface = domInterfaceFactory(HiveInterface);
HiveInterface.bsbridgeInterface = bsbridgeInterfaceFactory(HiveInterface);
HiveInterface.translateInterface = translateInterfaceFactory(HiveInterface);
HiveInterface.messageInterface = messageInterfaceFactory(HiveInterface);

/** @interface Utils */
const UtilsInterface = Utils;

// Set BS Version
UtilsInterface.setBsVersion(5);

/**
 *  Get Utils interface
 * @returns {Utils}
 */
HiveInterface.getUtils = () => UtilsInterface;

/**
 * Create a form handler instance
 * @param [controller]
 * @param [form]
 * @returns {FormHandler}
 */
HiveInterface.getFormHandler = (controller, form) => {
  if (typeof controller === 'undefined') return FormHandler;
  return new FormHandler(controller, form)
}

/**
 * Create a call handler instance
 * @param [controller]
 * @param [options]
 * @returns {CallHandler}
 */
HiveInterface.getCallHandler = (controller, options) => {
  if (typeof controller === 'undefined') return CallHandler;
  return new CallHandler(controller, options);
}

window.Hive = HiveInterface;
window.dispatchEvent(new CustomEvent(EVENT_BUILT));



